module.exports = __webpack_public_path__ + "static/media/Calendar.dc50c373.svg";